import { defineMessages } from 'react-intl';

export default defineMessages({
    placeholder: {
        id: 'components.projectInformation.component.ReportTextareaComment.placeholder',
        defaultMessage: 'Placeholder text', // DE:
    },
});
